import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Mark, SectionTitle } from './ui/Section';
export function Testimonials() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-229" data-mp="3fze45yusr5w7">
      <div className="mx-auto max-w-6xl" data-id="element-230" data-mp="3fxuooagysyvh">
        <SectionTitle data-id="element-231" data-mp="3b147fjtfbx8h">
          What rehabilitation professionals <Mark data-id="element-232" data-mp="3ayi09lag3jqs">are saying</Mark>
        </SectionTitle>

        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-6" data-id="element-233" data-mp="36z95cd3o5ftn">
          {testimonials.map((item, index) => <figure key={item.name} className={`flex flex-col rounded-2xl border border-brand/10 bg-white p-6 shadow-sm lg:col-span-2 ${index === 3 ? 'lg:col-start-2' : ''}`} data-id="element-234" data-mp="31ybe7b0olbg0" data-mpi={index}>
              <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-235" data-mp="2s3jjqg2eb4pg">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-accent text-accent" aria-hidden="true" data-id="element-236" data-mp="q9tvb9f0uee8" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-brand-deep" data-id="element-237" data-mp="h4dewra7py6t">“{item.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-brand/10 pt-4" data-id="element-238" data-mp="m2yeqpljyfuq">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand text-xs font-black text-white" data-id="element-239" data-mp="79v8hedevojb">
                  {item.initials}
                </span>
                <span data-id="element-240" data-mp="zyiwhhpjos0k">
                  <span className="block text-sm font-extrabold uppercase text-brand-deep" data-id="element-241" data-mp="14vj0zo6qxmpk">{item.name}</span>
                  <span className="block text-xs text-slate-600" data-id="element-242" data-mp="q6waqrfkzajk">{item.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
        <p className="mt-6 text-center text-xs text-slate-600" data-id="element-243" data-mp="v3d2dvlzo71e">Individual experiences may vary.</p>
      </div>
    </section>;
}